// extracted by mini-css-extract-plugin
export default {"btn-generate":"Button_btn-generate__9BsHp"};